module.exports = __webpack_public_path__ + "media/images/msg-icon-f0bc1a4c3ba57f2121d839ea5b883610.png";